import * as _ from 'lodash';
import {Injectable} from "@angular/core";

@Injectable()
export class NatureProvider {
    natures = [
        {code: 1, label: 'Alocação'},
        {code: 2, label: 'Unidade Fabril'},
        {code: 3, label: 'Projeto'},
        {code: 4, label: 'Consultoria'},
        {code: 5, label: 'Produto'},
        {code: 6, label: 'Recorrência produto'},
        {code: 7, label: 'Set-Up'},
        {code: 8, label: 'Licenciamento Cloud'},
        {code: 9, label: 'Squad'}
    ]

    find(natureCode) {
        const nature = this.natures.filter(nature => nature.code == natureCode);

        if (_.isEmpty(nature))
            throw 'Natureza inválida';

        return nature;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/enums/nature.provider.ts